module.exports = __webpack_public_path__ + "i18n/es.c364f8db633120bcd4d949925f03603b.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/es.json
// module id = 1538
// module chunks = 60